import { render, staticRenderFns } from "./helpBar.vue?vue&type=template&id=480f1414&"
import script from "./helpBar.vue?vue&type=script&lang=js&"
export * from "./helpBar.vue?vue&type=script&lang=js&"
import style0 from "./helpBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports